module.exports = __webpack_public_path__ + "static/media/followUpPhoneCall.c42035a5.png";